import ModalUserAiNavigator from "./ModalUserAiNavigator";

export default ModalUserAiNavigator;